
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'audit-logs-form-field-id',
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: String
        }
    },
    setup (_, { emit }) {
        const onUpdate = (value: string | null) => {
            if (value === null) {
                value = ''
            }
            emit('update:modelValue', value)
        }

        return {
            onUpdate
        }
    }
})
